var angular = require('angular');
var _module = angular.module('benoit');
var _ = require('lodash');

require('./_styles.scss');
require('angular-ui-router');
require('../third-party/angular-preload-image');
require('../../filters');
require('../favorite-btn');
require('../../services/search-results-utils');
require('../../services/lr-touch');
require('../../services/user');

_module.requires.push(
    'ui.router',
    'angular-preload-image'
);

_module.controller('ListingCardCtrl', [
    '$log',
    'srUtils',
    '$user',
    '$filter',

    function ListingCardCtrl($log, srUtils, $user, $filter) {
        $log.debug('ListingCardCtrl', this);

        var vm = this;
        vm.model = {
            nextOpenHouse: undefined,
            isFavorite: undefined
        };
        vm.events = {
            onFavoriteToggled: setIsFavorite,
            onListingClick: onListingClick
        };

        // Functions
        function setIsFavorite($value) {
            vm.model.isFavorite = $value;
        }

        function setNextOpenHouse() {
            if(_.get(vm.listing, 'open_houses')) {
                vm.model.nextOpenHouse = srUtils.getNextOpenHouse(vm.listing);
            }
        }

        function setHeroImage() {
            vm.listing.heroImage = vm.listing.hero || srUtils.getHeroImageUrl(vm.listing);
            vm.listing.heroImageFallback = vm.listing.heroImageFallback || srUtils.getFallbackHeroImageUrl(vm.listing);
        }

        function setMatchScore() {
            if(vm.listing.match_score || !vm.searchFilterId) return;

            $user
                .getSearchFilter(vm.searchFilterId)
            .then(function (searchFilter) {
                if(searchFilter) vm.listing.match_score = searchFilter.rankListing(vm.listing);
            });
        }

        function setDaysOnMarket() {
            vm.listing.days_on_market = vm.listing.days_on_market || srUtils.getDaysOnMarket(vm.listing);
        }

        function onListingClick() {
            srUtils.openDetailView({
                listingId: vm.listing.id,
                address: $filter('slug')(vm.listing.address),
                filter: vm.searchFilterId
            });
        }

        function init() {
            setNextOpenHouse();
            setHeroImage();
            setMatchScore();
            setDaysOnMarket();
        }

        // init
        init();
    }
]);

_module.component('listingCard', {
    controller: 'ListingCardCtrl',
    controllerAs: 'vm',
    template: require('./index.html'),
    bindings: {
        listing: '<',
        searchFilterId: '@',
        onClose: '&'
    }
});
